import { Tag } from 'antd';
import FilterInput from "components/Form/filterInput";
import { useCallback, useEffect, useState } from "react";

import { format } from "date-fns";
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toTitleCase } from "utils/common";

import { Button } from "components/Button";


const DocumentListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading, storeType, setStoreType, documentType}) => {
  const {
    department, departmentLoading,
    reportTo, reportToLoading,
    nationality, nationalityLoading,
    position, positionLoading,
    division, divisionLoading,
    costCenter, costCenterLoading,
    userData, userDataLoading
} = useSelector((state) => state.common);

const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {

   console.log(filters, "---filters in setinputvalueeeeeee")
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{
      console.log('useEffeeect')
    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading && !costCenterLoading && !userDataLoading){

      console.log(filters, "LLLs")

      let _appliedFilters = [...filters].map(item=>{
        // Use existing label/value if available, otherwise resolve from searchParams
        let label = item.label || ""
        let value = item.value || ""
        
        // Only resolve if label/value is missing or is an ID
        if(!value || (item.key !== "search" && !isNaN(value) && value !== "")){
          switch(item.key){
            case "issue_date_after":
              let date = searchParams.get("issue_date_after") || item.value || ""
              if(date){
                try {
                  value = format(new Date(date), "dd/MM/yyyy")
                } catch(e) {
                  value = date
                }
              }
              label = label || "Issued after"
              break;
            case "issue_date_before":
              let date_before = searchParams.get("issue_date_before") || item.value || ""
              if(date_before){
                try {
                  value = format(new Date(date_before), "dd/MM/yyyy")
                } catch(e) {
                  value = date_before
                }
              }
              label = label || "Issued before"
              break;
            case "expiry_date_before":
              let expiry_date_before = searchParams.get("expiry_date_before") || item.value || ""
              if(expiry_date_before){
                try {
                  value = format(new Date(expiry_date_before), "dd/MM/yyyy")
                } catch(e) {
                  value = expiry_date_before
                }
              }
              label = label || "Expiry before"
              break;
            case "expiry_date_after":
              let expiry_date_after = searchParams.get("expiry_date_after") || item.value || ""
              if(expiry_date_after){
                try {
                  value = format(new Date(expiry_date_after), "dd/MM/yyyy")
                } catch(e) {
                  value = expiry_date_after
                }
              }
              label = label || "Expiry after"
              break;
            case "document_type":
              let documentTypeId = searchParams.get("document_type") || item.value || ""
              if(documentTypeId){
                let selectedDocumentType = documentType?.length ? documentType.find(doc=>doc.id == documentTypeId) : null
                value = selectedDocumentType?.name || value || documentTypeId
                label = label || "Document Type"
              }
              break;
            case "company_user":
              let userId = searchParams.get("company_user") || item.value || ""
              if(userId){
                let selectedUser = userData?.length ? userData.find(user=>user.id == userId) : null
                value = selectedUser ? `${selectedUser.first_name} ${selectedUser.last_name}` : value || userId
                label = label || "User"
              }
              break;
            case "search":
              value = toTitleCase(searchParams.get("search") || item.value || "")
              label = label || "Search term"
              break;
            case "cost_center":
              let costCenterId = searchParams.get("cost_center") || item.value || ""
              if(costCenterId){
                let selectedCostCenter = costCenter?.length ? costCenter.find(cc=>cc.id == costCenterId) : null
                value = selectedCostCenter?.name || value || costCenterId
                label = label || "Cost Center"
              }
              break;
          }
        }
        
        return {
          ...item,
          value: value || item.value,
          label: label || item.label
        }
      })
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division,
    searchParams,
    costCenter,
    userData,
    documentType,
    departmentLoading,
    reportToLoading,
    nationalityLoading,
    positionLoading,
    divisionLoading,
    costCenterLoading,
    userDataLoading
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search" || item.key == "issue_date_after" || item.key == "issue_date_before" || item.key == "expiry_date_before" || item.key == "expiry_date_after" || item.key == "cost_center"){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-9 ">
          <div className="row" >
          <div className='col-sm-12 col-lg-4  ' >
        <FilterInput  
         defaultValue={setInputValue("search")} 
         onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
          id="search"
           label={searchPlaceholder}
            />
        </div>
        <div className='col-sm-12  col-lg-8  mt-1 flex-wrap' >
          
        {
            appliedFilters.map(item=>{
              return (
                <Tag icon={loading&&<i class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} className="mb-1" color={"red"} closeIcon={<i class="fa fa-times" aria-hidden="true"></i>} onClose={e=>handleClose(e, item)}>
                  {
                    item?.label
                  }
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              )
            })
          }

        </div>
          </div>


      
        </div>
      
 
        <div className="col-3 d-flex justify-content-end" style={{ paddingRight: 0 }}>
        {/* <div className="view-icons">
        <Button onClick={()=> {setStoreType(storeType=="user"? "store": "user")}}   icon={storeType=="user" ?"las la-store" : "las la-user"} 
        // id="collapse-header"
         className="list-view btn btn-link "/>
        </div> */}
        <div className="view-icons">
        <Button onClick={handleFilterDrawer} icon="las la-filter"
        //  id="collapse-header" 
         className="list-view btn btn-link "/>
        </div>
       
        </div>
      </div>
    </div>
  );
};

export default DocumentListFilter;
